<script setup lang="ts">
import ToastItem from '~/components/toast/ToastItem.vue';
import Text from '~/components/shared/Text.vue';
import { useToastStore } from '~/stores/toastStore';

const toastStore = useToastStore();
</script>

<template>
  <Teleport to="#teleport-container">
    <div class="toast-container">
      <transition name="toast-animation">
        <ToastItem v-if="toastStore.toast.isShowing" class="toast-container__toast">
          <Text white><span v-html="toastStore.toast.text"/></Text>
        </ToastItem>
      </transition>
    </div>
  </Teleport>
</template>

<style lang="scss" scoped>
.toast-container {
  &__toast {
    position: fixed;
    left: 50%;
    bottom: 32px;
    transform: translateX(-50%);
    transition: all var(--default-transition-duration-s);
    z-index: 1000;

    @media ($media-tablet) {
      bottom: calc(var(--tab-bar-height, 0) + var(--extra-toast-offset, 0px) + 16px);
      z-index: 100000;
    }
  }
}

.toast-animation-enter-from,
.toast-animation-leave-to {
  bottom: -32px;

  @media ($media-tablet) {
    bottom: -16px;
  }
}

.toast-animation-enter-to,
.toast-animation-leave-from {
  bottom: 32px;

  @media ($media-tablet) {
    bottom: calc(var(--tab-bar-height, 0) + var(--extra-toast-offset, 0px) + 16px);
  }
}
</style>
